import { Action, combineReducers, configureStore } from '@reduxjs/toolkit';
import { baseApi } from 'api/baseApi.ts';
import { clarityApi } from 'api/clarityApi.ts';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { bootstrapMiddleware } from './middleware/bootstrap';
import { disconnectRealtime, presenceService } from './realtime';
import bootstrapReducer from './store/bootstrapSlice';
import filtersReducer from './store/filtersSlice';
import presenceReducer from './store/presenceSlice';
import siteInfoReducer from './store/siteInfoSlice';
import tasksReducer from './store/tasksSlice';
import uiReducer from './store/uiSlice';
import { taskIdMiddleware } from './store/urlSync';
import userReducer from './store/userSlice';

// const logger = createLogger({
//   predicate: (getState, action) => {
//     return action.type !== 'ui/setFocusedContainer';
//   },
//   level: 'info',
//   collapsed: true,
// });

const appReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  [clarityApi.reducerPath]: clarityApi.reducer,
  bootstrap: bootstrapReducer,
  filters: filtersReducer,
  presence: presenceReducer,
  siteInfo: siteInfoReducer,
  tasks: tasksReducer,
  ui: uiReducer,
  user: userReducer,
});

const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: Action
) => {
  if (action.type === 'LOGOUT' || action.type === 'user/logout') {
    // Clear both old and new presence channels on logout
    presenceService.leaveAll();
    // Hard disconnect socket so presence truly leaves and avoids ghost users
    try {
      disconnectRealtime();
    } catch (_e) {}
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      baseApi.middleware,
      clarityApi.middleware,
      taskIdMiddleware.middleware,
      bootstrapMiddleware,
      // logger,
    ]),
  reducer: rootReducer,
  devTools: {
    name: 'Atarim Script',
    trace: true,
    traceLimit: 25,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
